import React, {Component} from 'react'
import {connect} from 'react-redux'
import {NavLink} from 'react-router-dom'
import {ROLES, isAllowed} from "./Permissions";

const showLink = (user, compRoles, component) => {
    if(isAllowed(user, compRoles)) {
        return component;
    } else {
        return null;
    }
};

class Navigation extends Component {
    render() {
        return (
            <div className='navbar'
            style={{"--nav-background-color":process.env.REACT_APP_NAV_BACKGROUND_COLOR,
            "--nav-hover-color":process.env.REACT_APP_NAV_HOVER_COLOR,
            "--nav-hover-text-color":process.env.REACT_APP_NAV_HOVER_TEXT_COLOR, 
            "--nav-text-color":process.env.REACT_APP_NAV_TEXT_COLOR
            }}>
                {showLink(
                    this.props.user,
                    [ROLES.COORDINATOR, ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN],
                    <NavLink exact activeClassName="active" to="/assessments">Assessments</NavLink>
                )}
                {showLink(
                    this.props.user,
                    [ROLES.COORDINATOR, ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN, ROLES.REVIEWER],
                    <NavLink exact activeClassName="active" to="/reviews">Reviews</NavLink>
                )}
                {showLink(
                    this.props.user,
                    [ROLES.COORDINATOR, ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN],
                    <NavLink exact activeClassName="active" to="/rubrics">Rubrics</NavLink>
                )}
                {showLink(
                    this.props.user,
                    [ROLES.COORDINATOR, ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN],
                    <NavLink exact activeClassName="active" to="/curriculummap">Curriculum Map</NavLink>
                )}
                {showLink(
                    this.props.user,
                    [ROLES.ADMIN],
                    <NavLink exact activeClassName="active" to="/users">Users</NavLink>
                )}

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {user: state.user}
}

export default connect(mapStateToProps, null, null, {pure: false})(Navigation);
